import { gql } from '@apollo/client';

import {
  productMetafieldSelection,
  productVariantMetafieldSelection,
} from './metafields';

const PRODUCT_METAFIELDS_FRAGMENT = productMetafieldSelection
  .map(
    (m) => `
  ${m}: metafield(key: "${m}", namespace: "pim") {
    type
    value
  }
`
  )
  .join('\n    ');

const PRODUCT_VARIANT_METAFIELDS_FRAGMENT = productVariantMetafieldSelection
  .map(
    (m) => `
  ${m}: metafield(key: "${m}", namespace: "pim") {
    type
    value
  }
`
  )
  .join('\n    ');

const productFragment = gql`
  fragment Product on Product {
    description
    handle
    id
    images(first: 10) {
      edges {
        node {
          url
        }
      }
    }
    inventory: metafield(namespace: "mustad-online-store", key: "inventory") {
      value
    }
    variants(first: 100) {
      edges {
        node {
          availableForSale
          compareAtPrice {
            amount
            currencyCode
          }
          currentlyNotInStock
          id
          price {
            amount
            currencyCode
          }
          ${PRODUCT_VARIANT_METAFIELDS_FRAGMENT}
          sku
        }
      }
    }
  }
`;

export const productByHandle = ({ countryCode, handle }) => {
  return {
    query: gql`
      ${productFragment}
      query ($countryCode: CountryCode!, $handle: String!)
      @inContext(country: $countryCode) {
        productByHandle(handle: $handle) {
          ...Product
        }
      }
    `,
    variables: {
      countryCode: countryCode,
      handle: handle,
    },
  };
};

export const collectionByHandle = ({ countryCode, handle }) => {
  return {
    query: gql`
      ${productFragment}
      query ($countryCode: CountryCode!, $handle: String!)
      @inContext(country: $countryCode) {
        collectionByHandle(handle: $handle) {
          products(first: 250, filters: { available: true }) {
            edges {
              node {
                ...Product
              }
            }
          }
        }
      }
    `,
    variables: {
      countryCode: countryCode,
      handle: handle,
    },
  };
};
